import React from "react";

import { Box, Typography } from "@mui/material";

import { ModernFormAlert } from "../../../../common/ModernForm";
import VideoTrimmer from "../../VideoTrimmer";
import { CustomShortVideoSuggestion } from "../../../types";
import { Episode } from "../../../../Episode/services/episode.service";

interface PreviewProps {
  selectedShortVideo: CustomShortVideoSuggestion;
  episode: Episode;
  handleTrimChange: (start: number, end: number) => void;
  trimmedEnd: number;
  trimmedStart: number;
}

export function Preview({
  selectedShortVideo,
  episode,
  handleTrimChange,
  trimmedEnd,
  trimmedStart,
}: PreviewProps) {
  return (
    <Box>
      <Box sx={{ mb: 3, p: 2, backgroundColor: "#f8fafc", borderRadius: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Selected Video Concept:
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {selectedShortVideo.title}
        </Typography>
      </Box>

      <VideoTrimmer
        videoUrl={episode.upload?.url || ""}
        initialStart={selectedShortVideo.start}
        initialEnd={selectedShortVideo.end}
        onTimeChange={handleTrimChange}
      />

      {trimmedEnd - trimmedStart > 120 && (
        <Box sx={{ mt: 2 }}>
          <ModernFormAlert severity="warning">
            Video duration cannot exceed 2 minutes. Please adjust the trimming.
          </ModernFormAlert>
        </Box>
      )}
    </Box>
  );
}
